import { Link } from 'react-router-dom';
import styled from 'styled-components';

export const Notice = styled.div`
  margin: ${({ theme }) => theme.spacing(1, 0, 2, 0)};
  padding: ${({ theme }) => theme.spacing(1.5, 2)};
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme.palette.divider};
  font-size: 14px;
  color: ${({ theme }) => theme.palette.text.secondary};
`;

// The row is a flex container, so it takes the full width to break onto its own line under the value.
export const Mismatch = styled.div`
  width: 100%;
  margin: ${({ theme }) => theme.spacing(0.5, 0, 1, 0)};
  font-size: 13px;
  line-height: 1.4;
  color: ${({ theme }) => theme.toast.warning.text};
`;

export const FixLink = styled(Link)`
  color: inherit;
  text-decoration: underline;

  &:hover {
    text-decoration: none;
  }
`;
